import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogData } from './dialog.interface';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  dialog = new Subject<DialogData | null>();

  constructor() { }

  setDialog(Dialog: DialogData) {
    this.dialog.next(Dialog);
  }

  clearDialog() {
    this.dialog.next(null);
  }
}
